import React from "react";

const FaqIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={fill}
        d="M10 2.25c-4.281 0-7.75 3.5-7.75 7.75 0 4.281 3.469 7.75 7.75 7.75 4.25 0 7.75-3.469 7.75-7.75 0-4.25-3.5-7.75-7.75-7.75zm0 14c-3.469 0-6.25-2.781-6.25-6.25 0-3.438 2.781-6.25 6.25-6.25 3.438 0 6.25 2.813 6.25 6.25 0 3.469-2.813 6.25-6.25 6.25zm3.344-7.969c0-1.562-1.656-2.781-3.188-2.781-1.469 0-2.406.625-3.125 1.719-.125.156-.093.375.063.5l.875.656c.156.125.406.094.531-.063.469-.593.813-.937 1.531-.937.563 0 1.25.344 1.25.906 0 .406-.344.594-.906.906-.625.376-1.469.813-1.469 1.938v.25c0 .219.156.375.375.375h1.406c.22 0 .376-.156.376-.375v-.188c0-.78 2.28-.812 2.28-2.906zM11.313 13.5c0-.719-.594-1.313-1.313-1.313-.75 0-1.313.594-1.313 1.313 0 .75.563 1.313 1.313 1.313.719 0 1.313-.563 1.313-1.313z"
      />
    </svg>

  );
};

FaqIcon.defaultProps = {
  fill: "#212226",
};
export default FaqIcon;
